module.exports = __webpack_public_path__ + "static/media/img-card-mask-2.dc1f4a9b.png";